// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"15597a30","90":"73e08611","131":"a3d8514b","178":"8565269e","304":"cea1baa6","349":"4c792426","381":"31a0c762","453":"3154de31","504":"953eea44","525":"4a03988a","574":"693ca370","776":"36eb6390","932":"cdb81d32","947":"d8b90576","966":"70ab561f","989":"7f1d23bb"}[chunkId] + ".chunk.js";
};